export default __webpack_public_path__ + "static/media/ticket-detail.3e5e7cd2.svg";